import { Breadcrumb } from "views/components/Navigation/Breadcrumbs";
import { OfficeInformation } from "./Office/OfficeInformation";
import { Skeleton } from "antd";
import { Spacer } from "./common/Spacer";
import { getColor } from "../resources/theme";
import { pathOr } from "ramda";
import { useGlobal } from "reactn";
import { useLocation } from "react-router-dom";
import React from "react";
import styled from "styled-components";

const Component = ({
	children,
	office,
	title,
	description,
	line,
	user,
	reserveScreen,
	userConfirmed,
}) => {
	const location = useLocation();
	const showSideColumn = location.pathname.includes("/lines");

	const [config] = useGlobal("UIConfig");
	const [reservationsv3] = useGlobal("reservationsv3");

	const { hideHomeBreadCrumb } = config;
	const oldIdReservation = pathOr(
		false,
		["oldIdReservation"],
		reservationsv3
	);

	const showBreadcrumb = !hideHomeBreadCrumb && !userConfirmed;

	return (
		<Wrapper>
			<SideColumn>
				{office ? (
					<OfficeInformation user={user} office={office} desktop />
				) : (
					<SkeletonOfficeInformation></SkeletonOfficeInformation>
				)}
			</SideColumn>
			<CenterColumn showSideColumn={showSideColumn}>
				{!!office && (
					<div style={{ padding: `24px 0px 42px` }}>
						{showBreadcrumb && !oldIdReservation && (
							<Breadcrumb office={office} />
						)}
					</div>
				)}
				<CenterColumnContent>
					{!reserveScreen && (
						<TopContainer>
							<Title>{`${title ? title : ""}`}</Title>

							{line && <Name>{`${line}`}</Name>}
						</TopContainer>
					)}

					<Description>{description}</Description>
					<Spacer rows={0.3} />
					{children}
				</CenterColumnContent>
			</CenterColumn>
			{showSideColumn && <SideColumn></SideColumn>}
		</Wrapper>
	);
};

const SkeletonOfficeInformation = () => {
	return (
		<SkeletonWrapper>
			<Skeleton.Avatar active size={100} shape="square" />
			<br></br>
			<Skeleton active></Skeleton>
		</SkeletonWrapper>
	);
};

export default Component;

export const Wrapper = styled.div`
	display: flex;
	background-color: #f5f5fb;
	margin: 0 auto;
	/* 	max-height: auto; */
	/* max-height: 750px; */
`;

const SkeletonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	align-items: center;
`;

const TopContainer = styled.div`
	width: 100%;
	padding-bottom: 16px;
	border-bottom: 1px solid #f0f0f0;
`;

export const SideColumn = styled.div`
	background-color: ${getColor("officeBackground")};
	width: 25%;
	padding: 36px;
`;

export const CenterColumn = styled.div`
	background-color: #fff;
	width: 50%;
	/* 	height: 100%; */
	max-width: 50%;
	padding: 0px 20px 40px;
	@media (max-width: 1024px) {
		max-width: 100%;
	}
`;

const CenterColumnContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: ${(props) => (props.reserveScreen ? "center" : "flex-start")};
	padding: 0;
	height: 90%;
	overflow-y: scroll;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
`;

const Title = styled.h3`
	color: ${getColor("primary")};
	margin: 0;
	text-align: left;
	width: 100%;
`;
const Name = styled.h4`
	color: ${getColor("primary")};
	margin: 0;
	text-align: left;
	width: 100%;
	font-size: 16px;
	font-weight: 500;
`;

const Description = styled.h4`
	color: ${getColor("primary")};
`;
